import React, { Fragment } from 'react';

import { withT } from '../context/t.js';
import { getSectionT } from '../i18n.js';

import Link from './Link.jsx';

const LinkPrevNext = props => {
  const renderPrevLink = title => {
    return (
      <>
        <span className="nav-sequential__caret">
          <i className="fas fa-caret-left" />
        </span>
        <span className="nav-sequential__clarity-text">
          {props.t('interface:backLink')}
        </span>
        <span className="nav-sequential__page-name">{title}</span>
      </>
    );
  };

  const renderNextLink = title => {
    return (
      <>
        <span className="nav-sequential__clarity-text">
          {props.t('interface:forwardLink')}
        </span>
        <span className="nav-sequential__page-name">{title}</span>
        <span className="nav-sequential__caret">
          <i className="fas fa-caret-right" />
        </span>
      </>
    );
  };

  return (
    <nav className="nav-sequential">
      {props.previousSlug ? (
        <Link
          className="nav-sequential__prev"
          to={'section/' + props.previousSlug}
          title={renderPrevLink(getSectionT(props.previousSlug)('title'))}
        />
      ) : (
        <Link
          className="nav-sequential__prev"
          to=""
          title={renderPrevLink(props.t('landing:title'))}
        />
      )}
      {props.nextSlug ? (
        <Link
          className="nav-sequential__next"
          to={'section/' + props.nextSlug}
          title={renderNextLink(getSectionT(props.nextSlug)('title'))}
        />
      ) : (
        <Link
          className="nav-sequential__next"
          to={props.t(`results:slug`)}
          title={renderNextLink(props.t('results:title'))}
        />
      )}
      {
        // HACK: adds some spacing before the right-pointing arrow. This should not survive any refactor.
        // Ideas for the future:
        //  - stop using pseudoselectors to add the 'back to' and 'next:' content
        //  - instead, put those strings in translation strings and use them in this file
        //  - or, at the very least, display those strings in this file.
        ' '
      }
    </nav>
  );
};

export default withT()(LinkPrevNext);
